import { useState, useEffect, createRef } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//-----------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import AutoComplete from "src/components/common/autoComplete";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Thumbnail from "src/components/common/thumbnail";
import { useMyStore } from "src/components/main/mainStore";
import {
    Select, MyDate, handleFilesInput, 
    timepicker, restDayProjectHashKey, 
    myAxios, projectCategoryColorCode,
    subPipelineOptions
} from "src/components/common/functions";
export const laborCategorys = [
    "General Labor",
    "SoCal Labor NPLA", 
    "NorCal Labor NPLA", 
    "Locating", 
    "USA Mark", 
    "StandBy", 
    "Foreman",
    "Surface Removal", 
    "Surface Restoration", 
    "Traffic Control", 
    "GPR & Concrete Scaning & Coring", 
    "GPR & Concrete Scanning", 
    "GPR & Concrete Coring", 
    "Surveying", 
    "Mapping", 
    "Reports", 
    "CCTV", 
    "Hydro Flushing",
    "QA/QC",
    "Training",
    "Travel",
    "Pothole Operator - Local 3 NPLA",
    "Pothole Operator - Local 12 NPLA",
	"Pothole Labor - Nor Cal",
	"Pothole Labor Helper - Nor Cal",
	"Pothole Labor Helper - So Cal",
	"Pothole Labor - So Cal",
	"Pothole Operator - Local 3",
	"Pothole Operator - Local 12",
	"Labor Locator - Nor Cal",
	"Labor Locator - So Cal",
	"1245 Locator", 
    "Saw Cutting", 
    "Specialty Vaccum",
    "Intern"
];
export const laborShopsCategorys = [
    "Hayward Shop", 
    "Fremont Shop", 
    "Gilroy Shop", 
    "Fresno Shop", 
    "Ontario Shop", 
    "Sacramento Shop", 
    "Training", 
];
//-----------------------------------------------------------------------------------------
export default function WorkInstructionForm({
    closeIt, 
    handleSubmit, 
    title, 
    keyword, 
    userList, 
    showFilesInput, 
    selectedUsers, 
    setSelectedUsers, 
    siteContacts, 
    project, 
    mnt, 
    history, 
    //---------------------
    setCurrentWorkInstruction, 
    workInstruction, 
    workLogs, 

    setCurrentWorkInstructionRenderSwitch, 
    setProjectDetailRenderSwitch, 
    setWorkInstructionRenderSwitch, 

    ...rest
    /*startTime, endTime, calendarLocation, coords, 
    workInstructionDescription, files1id */
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const categoryOptions = Object.keys(projectCategoryColorCode);
    //const projectId = history.location.pathname.split("/")[2];
    //const workInstructionId = history.location.pathname.split("/")[4];
    const options = userList.length?userList.filter(u => u.workLogs !== "no").map(u => ({
        value: u.email, 
        label: u.userName, 
        email: u.email, 
        userName: u.userName, 
        laborCategory: "", 
        truckNumber: "", 
        trailerNumber: "",
        perDiem: "", 

        unionName: u.unionName,
        disabled: u.quitDate,
        thumbnail: u.thumbnail
    })):[];
    const laborsCategory = e => {
        setSelectedUsers(
            selectedUsers.map(user => (
                user.email === e.currentTarget.getAttribute("laborcategory")?
                {
                    ...user, 
                    laborCategory: e.currentTarget.value
                }:
                user
            ))
        );
    }
    const trucksNumber = e => {
        setSelectedUsers(
            selectedUsers.map(user => (
                user.email === e.currentTarget.getAttribute("trucknumber")?
                {
                    ...user, 
                    truckNumber: e.currentTarget.value
                }:
                user
            ))
        );
    }
    const trailerNumberChange = e => {
        setSelectedUsers(
            selectedUsers.map(user => (
                user.email === e.currentTarget.getAttribute("trailernumber")?
                {
                    ...user, 
                    trailerNumber: e.currentTarget.value
                }:
                user
            ))
        );
    }
    const handlePerDiem = e => {
        setSelectedUsers(
            selectedUsers.map(user => (
                user.email === e.currentTarget.getAttribute("perdiem")?
                {
                    ...user, 
                    perDiem: e.currentTarget.value
                }:
                user
            ))
        );
    }
    const newLaborsSelect = e => {
        setSelectedUsers(e?.map(s => selectedUsers.filter(u => u.email === s.email).length?
        selectedUsers.filter(u => u.email === s.email)[0]:
        s));
    }
    // const handleLocalSubmit = async e => {
    //     let reset, url;
    //     e.preventDefault();
    //     /*
    //     if(selectedUsers.length === 0){
    //         window.alert("Select at least one labor!");
    //         return;
    //     }
    //     */
    //     const formData = new MyFormData(e.currentTarget);
    //     if(formData.get("allDay") === null){
    //         formData.set("allDay", "");
    //     }
    //     if(!formData.get("calendarLocation")){
    //         window.alert("Location is not valid!");
    //         return;
    //     };
    //     if(new Date(formData.get("startDate").replace(/-/g, "/") + " " + getTime(formData.get("startTime"))) > new Date(formData.get("endDate").replace(/-/g, "/") + " " + getTime(formData.get("endTime")))){
    //         window.alert("Start time is greater than end time!");
    //         return;
    //     };
    //     if(formData.get("startDate") !== formData.get("endDate") && !window.confirm("is this a night job?")){
    //         window.alert("Start date is different from end Date. Please check.");
    //         return;
    //     }
    //     if(keyword === "Edit"){
    //         if(
    //             workInstruction.startTime.substring(0, 10) !== formData.get("startDate") ||
    //             workInstruction.endTime.substring(0, 10) !== formData.get("endDate")
    //         ){
    //             if(!window.confirm("You are updating the date. Proceed?")) return;
    //         }
    //         const isTimeChanged = (
    //             formData.get("startDate") !== workInstruction.startTime.substring(0, 10) || 
    //             formData.get("endDate") !== workInstruction.endTime.substring(0, 10)
    //         );
    //         const cautionStatus = workLogs.filter(c => c.jobTagSubmitTime !== defaultEmptyDateTime).length;
    //         reset = "no";
    //         if(isTimeChanged && cautionStatus){
    //             reset = "yes";
    //         }
    //         if(reset === "yes" && !window.confirm(
    //             `this work Instruction already have job tag(s) submitted. You are changing time, this will cause all their works neeed to be re-submitted. Continue?`
    //         )){
    //             return;
    //         }
    //         url = "workInstructions/updateWorkInstruction.php";
    //         formData.append("workInstructionHashKey", workInstruction.workInstructionHashKey);
    //         formData.append("eventId", workInstruction.eventId);
    //         formData.append("calendarId", workInstruction.calendarId);
    //         formData.append("prevLabors", JSON.stringify(workLogs.map(user => JSON.stringify({
    //             email: user.email, 
    //             laborCategory: user.laborCategory, 
    //             truckNumber: user.truckNumber, 
    //             perDiem: user.perDiem, 
    //             name: user.label || user.userName
    //         }))));
    //         formData.append("folderId", workInstruction.folderId);
    //         formData.append("attachmentFolderId", workInstruction.attachmentFolderId);
    //         formData.append("workLogs", JSON.stringify(workLogs));
    //         formData.append("reset", reset);
    //     }else{
    //         url = "workInstructions/createWorkInstruction.php";
    //         formData.append("projectManagerEmail", project.projectManagerEmail);
    //         formData.append("projectFolderId", project.projectFolderId);
    //     }
    //     formData.append("projectHashKey", project.projectHashKey);
    //     const jobWeek = weeknum(workInstruction.startTime.substring(0, 10));
    //     const today = new MyDate();
    //     const late = ((weeknum(today)) > changeWeek(jobWeek, 1)) || (
    //         (weeknum(today)) > jobWeek && 
    //         (
    //             ((today.getDay() === 2) && today.getHours() >= 12)
    //             || (today.getDay() > 2 || today.getDay() === 0)
    //         )
    //     ); // by Tuesday noon
    //     if(late){
    //         //window.alert("StartDate is too old. We will send an email to payroll.");return;
    //         if(!window.confirm("StartDate is too old. We will send an email to payroll.")) return;
    //         if(keyword === "Edit"){
    //             formData.append("emailToName", JSON.stringify(userList.map(u => ({[u.email]:u.userName.replace(/ {2}/g, " ")})).reduce(objectReducer, {})));
    //             formData.append("projectName", project.projectName);
    //         }else{
    //             formData.append("toPayroll", `${user.userName} added ${selectedUsers.map(s => s.label).join(", ")} to ${project.projectName}  ${formData.get("startDate")}`);
    //         }
    //     }
    //     const supervisorEmail = formData.get("supervisorEmail");
    //     if(supervisorEmail){
    //         const supervisor = userList.filter(u => u.email === supervisorEmail)[0];
    //         const supervisorName = supervisor.middleName?`${supervisor.firstName} ${supervisor.middleName} ${supervisor.lastName}`:`${supervisor.firstName} ${supervisor.lastName}`;
    //         formData.append("supervisorName", supervisorName);
    //     }
    //     formData.append("labors", JSON.stringify(selectedUsers.map(user => JSON.stringify({
    //         email: user.email, 
    //         laborCategory: user.laborCategory, 
    //         truckNumber: user.truckNumber, 
    //         perDiem: user.perDiem, 
    //         name: user.label || user.userName
    //     }))));
    //     setShowLoader(true);
    //     const res = await myAxios(url, formData);
    //     setShowLoader(false);
    //     setProjectDetailRenderSwitch(s => !s);
    //     setWorkInstructionRenderSwitch(s => !s);
    //     setCurrentWorkInstructionRenderSwitch(s => !s);
    //     setSelectedUsers([]);
    //     setCurrentWorkInstruction(null);
    //     history.replace(`/Projects/${projectId}`);
    // }
    //-----------------------------------------------------------------------------------------    
    const [curAllDay, setAllDay] = useState(rest.allDay === undefined?true:(rest.allDay === ""?false:true));
    const [curStartTime, setStartTime] = useState(rest.startTime?rest.startTime.slice(11, 16):"");
    const [curEndTime, setEndTime] = useState(rest.endTime?rest.endTime.slice(11, 16):"");
    const [curOvernight, setOvernight] = useState((rest.startTime?rest.startTime.slice(0,10):"") !== (rest.endTime?rest.endTime.slice(0,10):""));
    const [curStartDate, setStartDate] = useState(rest.startTime?rest.startTime.slice(0, 10):"");
    const [curEndDate, setEndDate] = useState(rest.endTime?rest.endTime.slice(0, 10):"");
    
    const [category, setCategory] = useState(rest.category ?? "");
    const [subCategory, setSubCategory] = useState(rest.subCategory ?? "");
    const subCategoryOptions = subPipelineOptions[category] ?? [];
    const [supervisorEmail, setSupervisorEmail] = useState(rest.supervisorEmail ?? "");
    const [curSiteContactHashKey, setSiteContactHashKey] = useState(rest.siteContactHashKey || "");
    const [cadRequired, setCAD] = useState(rest.cadRequired || "");
    const [reportRequired, setReport] = useState(rest.reportRequired || "");

    const [fieldSupervisorName, setFieldSupervisorName] = useState(rest.fieldSupervisorName || "");
    const [fieldSupervisorEmail, setFieldSupervisorEmail] = useState(rest.fieldSupervisorEmail || "");
    const [delayJSA, setDelayJSA] = useState(rest.delayJSA === "1");

    const [trucks, setTrucks] = useState([]);
    const [trailers, setTrailers] = useState([]);

    const [workInstructionDescription, setWorkInstructionDescription] = useState(rest.workInstructionDescription || "");

    useEffect(() => {
        let isMounted = true;
        const getWorkLogsData = async () => {
            //-----------------------------------------------------------
            setShowLoader(true);
            const resTrucks = await myAxios("common/readTruckNumbersOnlyNew.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTrucks) return;
            //-----------------------------------------------------------
            setTrucks(resTrucks.data);
        }
        const getTrailerLogsData = async () => {
            //-----------------------------------------------------------
            setShowLoader(true);
            const resTrailers = await myAxios("common/readTrailerNumbersOnly.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTrailers) return;
            //-----------------------------------------------------------
            setTrailers(resTrailers.data);
        }

        getWorkLogsData();
        getTrailerLogsData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    },[setShowLoader])
    //-----------------------------------------------------------------------------------------
    return (
        <Modal
            closeIt = {closeIt}
            title = {title}
            width = {"80rem"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <TransitionWidthHeight 
            timeout = {700}
            classNames = "WITrans"
            In = {mnt}
            children = {
            <div>
                <div className = "d-flex align-items-center mt-2">
                    {project.projectHashKey !== restDayProjectHashKey?
                    <div className = "d-flex align-items-center m-2">
                        <input
                            id = "allDay"
                            type = "checkbox"
                            name = "allDay"
                            className = "mr-2 cssCheckBox"
                            value = "yes"
                            checked = {curAllDay}
                            onChange = {e => {
                                setAllDay(e.currentTarget.checked);
                                setStartTime("");
                                setEndTime("");
                            }}
                        />
                        <label className = "font-weight-bold" htmlFor = "allDay">All Day</label>
                    </div>
                    :
                    <input
                        type = "text"
                        className = "nodisplay" readOnly
                        name = "allDay" value = "yes"
                    />
                    }
                    <div className = "d-flex align-items-center m-2 flex-grow-1">
                        <label htmlFor = "startDate" className = "font-weight-bold mr-2">Start:<span className = "text-danger">*</span></label>
                        <input
                            id = "startDate"
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            required
                            className = "form-control flex-grow-1 mr-2"
                            name = "startDate"
                            value = {curStartDate}
                            onChange = {e => {
                                setStartDate(e.currentTarget.value);
                                if(!curOvernight){
                                    setEndDate(e.currentTarget.value);
                                }else{
                                    const nextDay = new MyDate(`${e.currentTarget.value.replace(/-/g, "/")} 06:00`);
                                    nextDay.setDate(nextDay.getDate() + 1);
                                    setEndDate(nextDay.s());
                                }
                            }}
                        />
                        {!curAllDay?
                        <select readOnly = {curAllDay} className = "form-control flex-grow-1" name = "startTime" required value = {curStartTime} onChange = {e => {
                            if(curStartDate){
                                setStartTime(e.currentTarget.value);
                            }else{
                                window.alert("Set start date first.");
                                return;
                            }
                        }}>
                            <option value = "">Select</option>
                            {timepicker().map((t, i) => 
                            <option 
                                key = {i} 
                                disabled = {
                                    new Date(`${curEndDate.replace(/-/g, "/")} ${curEndTime || "24:00"}`) <= new Date(`${curStartDate.replace(/-/g, "/")} ${t.value}`) 
                                } 
                                value = {t.value}
                            >
                                {t.text}
                            </option>)}    
                        </select>
                    :null}
                    </div>
                    <div className = "d-flex align-items-center m-2">
                        <input
                            id = "overnight"
                            type = "checkbox"
                            name = "overnight"
                            className = "cssCheckBox mr-2"
                            checked = {curOvernight}
                            onChange = {e => {
                                if(curStartDate){
                                    setOvernight(e.currentTarget.checked);
                                }else{
                                    window.alert("Set start date first.");
                                    return;
                                }
                                if(e.currentTarget.checked){
                                    const nextDay = new MyDate(`${curStartDate.replace(/-/g, "/")} 06:00`);
                                    nextDay.setDate(nextDay.getDate() + 1);
                                    setEndDate(nextDay.s());
                                }else{
                                    setEndDate(curStartDate);
                                }
                            }}
                        />
                        <label className = "font-weight-bold" htmlFor = "overnight">Overnight</label>
                    </div>
                    <div className = "d-flex align-items-center m-2 flex-grow-1">
                        <label htmlFor = "endDate" className = "font-weight-bold mr-2">End:<span className = "text-danger">*</span></label>
                        <input
                            id = "endDate"
                            type = "date"
                            required = {curOvernight}
                            readOnly = {true}
                            className = "form-control flex-grow-1 mr-2"
                            name = "endDate"
                            value = {curEndDate}
                            onChange = {e => {
                                setEndDate(e.currentTarget.value);
                            }}
                        />
                        {!curAllDay?
                        <select readOnly = {curAllDay} className = "form-control flex-grow-1" name = "endTime" required value = {curEndTime} onChange = {e => {
                            if(curStartDate){
                                setEndTime(e.currentTarget.value);
                            }else{
                                window.alert("Set start date First");
                                return;
                            }
                        }}>
                            <option value = "">Select</option>
                            {timepicker().map((t, i) => 
                            <option 
                                key = {i} 
                                disabled = {
                                    new Date(`${curEndDate.replace(/-/g, "/")} ${t.value}`) <= new Date(`${curStartDate.replace(/-/g, "/")} ${curStartTime || "00:00"}`) 
                                } 
                                value = {t.value}
                            >
                                {t.text}
                            </option>)}
                        </select>
                        :null}
                    </div>
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <div className = "font-weight-bold required-field mr-2">Location:</div>
                    
                    <AutoComplete 
                        className = ""
                        location = {rest.location}
                        coords = {rest.coords?rest.coords.split(",").map(Number):undefined} 
                        locationName = "calendarLocation" 
                        coordsName = "coords"
                        projectLocation = {project.location} 
                        projectCoords = {project.coords}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "prevCalendarLocation"
                        value = {rest.location || ""}
                    />
                </div>

                <div className = "d-flex align-items-center mb-2">
                    <input readOnly className = "nodisplay" name = "oldCategory" value = {rest.category || ""}/>
                    <label htmlFor = "category" className = "font-weight-bold mr-3">Category:</label>
                    <select
                        id = "category"
                        required
                        className = "form-control flex-grow-1"
                        name = "category"
                        value = {category}
                        onChange = {e => setCategory(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        {categoryOptions.map((opt, key) => 
                        <option key = {key} value = {opt}>
                            {opt}
                        </option>
                        )}
                    </select>
                </div>
                {subCategoryOptions.length?
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "subCategory" className = "font-weight-bold mr-3">Sub Category:</label>
                    <select
                        id = "subCategory"
                        className = "form-control flex-grow-1"
                        name = "subCategory"
                        value = {subCategory}
                        onChange = {e => setSubCategory(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        {subCategoryOptions.map((opt, key) => 
                        <option key = {key} value = {opt}>
                            {opt}
                        </option>
                        )}
                    </select>
                </div>
                :<></>}
                <div className = "d-flex align-items-center mb-2">
                        {category === "GPR Concrete Scanning and Coring Project"?
                        <>
                            <label htmlFor = "fieldSupervisorName" className = "font-weight-bold required-field mr-2">
                                Field Supervisor Name:
                            </label>
                            <input
                                id = "fieldSupervisorName"
                                type = "text"
                                required
                                className = "form-control flex-grow-1 mr-2"
                                name = "fieldSupervisorName"
                                value = {fieldSupervisorName}
                                onChange = {e => setFieldSupervisorName(e.currentTarget.value)}
                            />
                            <label htmlFor = "fieldSupervisorEmail" className = "font-weight-bold required-field mr-2">
                                Field Supervisor Email:
                            </label>
                            <input
                                id = "fieldSupervisorEmail"
                                type = "email"
                                required
                                className = "form-control flex-grow-1"
                                name = "fieldSupervisorEmail"
                                value = {fieldSupervisorEmail}
                                onChange = {e => setFieldSupervisorEmail(e.currentTarget.value)}
                            />
                        </>
                        : 
                        <>
                            <label htmlFor = "supervisorEmail" className = "font-weight-bold mr-3">Supervisor:</label>
                            <select
                                id = "supervisorEmail"
                                required
                                className = "form-control flex-grow-1"
                                name = "supervisorEmail"
                                value = {supervisorEmail}
                                onChange = {e => {setSupervisorEmail(e.currentTarget.value)}}
                            >
                                <option value = "">Select</option>
                                {userList.filter(u => u.role.toLowerCase().indexOf("supervisor") > -1).map((user, key) => <option key = {key} value = {user.email}>{user.userName}</option>)}
                            </select>
                            <input
                                className = "nodisplay" readOnly
                                name = "prevSupervisorEmail"
                                value = {rest.supervisorEmail || ""}
                            />
                        </>
                    }
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "requesterName" className = "font-weight-bold mr-3">Requester Name:</label>
                    <input
                        id = "requesterName"
                        className = "form-control flex-grow-1 mr-3"
                        readOnly
                        value = {siteContacts.filter(siteContact => 
                            siteContact.contactHashKey === project.requestorHashKey
                        )[0]?.contactName || ""}
                    />
                    <label htmlFor = "requesterMobile" className = "font-weight-bold mr-3">Mobile:</label>
                    <input
                        id = "requesterMobile"
                        className = "form-control flex-grow-1"
                        readOnly
                        value = {siteContacts.filter(siteContact => 
                            siteContact.contactHashKey === project.requestorHashKey
                        )[0]?.mobile || ""}
                    />
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "siteContactHashKey" className = "font-weight-bold mr-3">Site Contact:</label>
                    <select
                        id = "siteContactHashKey"
                        className = "form-control flex-grow-1 mr-2"
                        name = "siteContactHashKey"
                        value = {curSiteContactHashKey || ""}
                        onChange = {e => {
                            setSiteContactHashKey(e.currentTarget.value);
                        }}>
                        <option value = "">Select</option>
                        {siteContacts.map((siteContact, siteContactIndex) => <option key = {siteContactIndex} value = {siteContact.contactHashKey}>{siteContact.contactName}</option>)}
                    </select>
                    <label htmlFor = "siteContactMobile" className = "font-weight-bold mr-3">Mobile:</label>
                    <input
                        id = "siteContactMobile"
                        className = "form-control flex-grow-1"
                        readOnly
                        value = {siteContacts.filter(siteContact => 
                            siteContact.contactHashKey === curSiteContactHashKey
                        )[0]?.mobile || ""}
                    />
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <label htmlFor = "cadRequired" className = "font-weight-bold mr-3">CAD required:</label>
                    <select
                        id = "cadRequired"
                        className = "form-control flex-grow-1 mr-3"
                        name = "cadRequired"
                        value = {cadRequired}
                        onChange = {e => {setCAD(e.currentTarget.value)}}
                    >
                        <option value = {""}>Select</option>
                        <option value = {"1"}>Yes</option>
                        <option value = {"0"}>No</option>
                    </select>
                    <label htmlFor = "reportRequired" className = "font-weight-bold mr-3">Report required:</label>
                    <select
                        id = "reportRequired"
                        className = "form-control flex-grow-1 mr-3"
                        name = "reportRequired"
                        value = {reportRequired}
                        onChange = {e => {setReport(e.currentTarget.value)}}
                    >
                        <option value = {""}>Select</option>
                        <option value = {"1"}>Yes</option>
                        <option value = {"0"}>No</option>
                    </select>
                </div>
                <div className = "d-flex align-items-center mb-2">
                    <input
                        id = "delayJSA"
                        type = "checkbox"
                        name = "delayJSA"
                        className = "cssCheckBox"
                        value = "1"
                        checked = {delayJSA}
                        onChange = {e => {
                            setDelayJSA(e.currentTarget.checked);
                        }}
                    />
                    <label htmlFor = "delayJSA" className = "font-weight-bold ml-2">Waive JSA</label>
                </div>
                <div className = "d-flex align-items-center">
                    <label className = "font-weight-bold">
                        Technician(s):
                    </label>
                    <div className = "flex-grow-1 ml-3">
                        <Select 
                            name = "techSelect"
                            required = {false}
                            isMulti 
                            options = {options} 
                            isOptionDisabled = {(option) => option.disabled}
                            value = {selectedUsers.map(s => ({...s, value: s.email, label: <>
                            <Thumbnail value = {s.thumbnail} side = {50}/>
                            {s.userName}</>}))} 
                            onChange = {newLaborsSelect}
                        />
                    </div>
                </div>
                <TransitionGroup className = {selectedUsers.length > 0?"rounded border mt-3 overflow-auto":null}>
                    {selectedUsers.map(({email, userName, laborCategory, truckNumber, trailerNumber, perDiem, unionName}) => {
                        const itemRef = createRef(null);
                        return(
                            <CSSTransition 
                                key = {email}
                                timeout = {300}
                                classNames = "cssTDTransition"
                                nodeRef = {itemRef}
                            >
                                <div ref = {itemRef} className = "p-2">
                                    <div className = "d-flex align-items-center mb-2">
                                        <label className = "ml-3 font-weight-bold">{userName}:</label>
                                        <label className = "ml-3 text-success">{unionName}</label>
                                        <select className = "form-control ml-2" laborcategory = {email} value = {laborCategory} required onChange = {laborsCategory}>
                                            <option value = "" disabled>Select</option>
                                            {project.projectHashKey === restDayProjectHashKey?<>
                                            <option>Rest Day</option>
                                            <option>Vacation</option>
                                            <option>Sick</option>
                                            </>:
                                            <>
                                                {project.organizationName !== "BESS Utility Solutions"?<>
                                                <optgroup label = "Job Category">
                                                    {laborCategorys.map((x, xi) => <option key = {xi}>{x}</option>)}
                                                    {laborCategory && !laborCategorys.includes(laborCategory)?<option>{laborCategory}</option>:<></>}
                                                </optgroup>
                                                <optgroup label = "Others">
                                                    <option>Images</option>
                                                </optgroup>
                                                </>:<>
                                                {laborShopsCategorys.map((x, xi) => <option key = {xi}>{x}</option>)}
                                                </>}
                                            </>
                                            }
                                        </select>
                                    </div>
                                    <div className = "d-flex align-items-center">
                                        <label className = "font-weight-bold text-info ml-3">Truck Number</label>
                                        <select className = "text-info form-control ml-2" trucknumber = {email} value = {truckNumber} onChange = {trucksNumber}>
                                            <option value = "">Select</option>
                                            {
                                                trucks.map((truckNumber, truckNumberIndex) => <option key = {truckNumberIndex}>{truckNumber}</option>)
                                            }
                                        </select>
                                        <label className = "font-weight-bold text-info ml-3">Trailer Number</label>
                                        <select className = "text-info form-control ml-2" trailernumber = {email} value = {trailerNumber} onChange = {trailerNumberChange}>
                                            <option value = "">Select</option>
                                            {
                                                trailers.map((trailerNumber, trailerNumberIndex) => <option key = {trailerNumberIndex}>{trailerNumber}</option>)
                                            }
                                        </select>
                                        <label className = "font-weight-bold text-success ml-3">Per Diem</label>
                                        <select className = "text-success form-control ml-2"
                                            perdiem = {email}
                                            value = {perDiem}
                                            onChange = {handlePerDiem}
                                        >
                                            <option value = "">No</option>
                                            <option>Yes</option>
                                        </select>
                                        <input
                                            type = "radio"
                                            required = {true}
                                            id = {email + " JSA"}
                                            name = "lead"
                                            defaultChecked = {rest.teamLead === email}
                                            value = {email}
                                            className = "cssCheckBox ml-3"
                                        />
                                        <label htmlFor = {email + " JSA"} className = "font-weight-bold text-primary ml-2">JSA</label>
                                    </div>
                                </div>
                            </CSSTransition>
                        )
                    })}
                </TransitionGroup>
                <div>
                    <label htmlFor = "description" className = "font-weight-bold mt-2">Description:</label>
                    <div className = "mt-2">
                        <CKEditor
                            id = "description"
                            editor = {ClassicEditor}
                            config = {{
                                    toolbar: [
                                    "selectAll", "undo", "redo", "bold", "italic", 
                                    "numberedList", "bulletedList"
                                ]
                            }}
                            data = {workInstructionDescription}
                            onChange = {(e, editor) => {
                                setWorkInstructionDescription(editor.getData()); 
                            }}
                        />
                    </div>
                    <input
                        className = "nodisplay" readOnly
                        name = "prevWorkInstructionDescription"
                        value = {rest.workInstructionDescription || ""}
                    />
                    <input
                        readOnly className = "nodisplay"
                        name = "workInstructionDescription"
                        value = {workInstructionDescription || ""}
                    />
                </div>
                <div className = "d-flex align-items-center mt-2 mb-2">
                {showFilesInput?<>
                <label htmlFor = {rest.files1id ?? "attachments"} className = "">Attachments</label>
                <div className = "custom-file ml-3">
                    <input
                        type = "file"
                        multiple
                        className = "custom-file-input"
                        name = "files[]"
                        id = {rest.files1id ?? "attachments"} 
                        onChange = {handleFilesInput}
                    />
                    <label className = "custom-file-label">Choose file(s)</label>
                </div>
                </>:<br/>}
                </div>
            </div>}/>
        </Modal>
    )
}